<template>
  <div>
    <h2>Conjunto de imagens</h2>
    <form action="" class="md-layout" @submit.prevent="submit">
      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('graphicalViewId')"
      >
        <label for="graphicalViews">Conjunto de imagens</label>
        <md-select
          id="graphicalViews"
          v-model="graphicalViewId"
          name="graphicalViews"
          md-dense
        >
          <md-option
            v-for="graphicalView in graphicalViews"
            :key="graphicalView.id"
            :value="graphicalView.id"
          >
            {{ graphicalView.titulo }}
          </md-option>
        </md-select>
        <span
          v-if="$v.graphicalViewId && !$v.graphicalViewId.required"
          class="md-error"
        >
          Conjunto de imagens é obrigatório
        </span>
      </md-field>
      <sensor-autocomplete
        id="sensores"
        v-model="sensorId"
        name="sensores"
        class="md-layout-item md-size-100"
        :local-id="localId"
      />
      <sensor-virtual-autocomplete
        id="sensorVirtualId"
        v-model="sensorVirtualId"
        name="sensorVirtualId"
        class="md-layout-item md-size-100"
        :local-id="localId"
      />

      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('max')"
      >
        <label for="max">Máximo</label>
        <md-input id="max" v-model.number="max" type="number" />
        <span v-if="$v.max && !$v.max.required" class="md-error">
          Máximo é obrigatório
        </span>
      </md-field>
      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('min')"
      >
        <label for="min">Mínimo</label>
        <md-input id="min" v-model.number="min" type="number" />
        <span v-if="$v.min && !$v.min.required" class="md-error">
          Mínimo é obrigatório
        </span>
      </md-field>
      <div style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          {{ isEdit ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { EventBus, Topics, Types } from '@/event-bus'
import { ComponenteTipo } from '@/utils/componente'
import http from '@/utils/http'

import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'
import SensorVirtualAutocomplete from '../../autocomplete/SensorVirtualAutocomplete.vue'

export default {
  name: 'ViewGraphicalForm',
  components: { SensorAutocomplete, SensorVirtualAutocomplete },
  mixins: [validationMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      graphicalViewId: null,
      sensorId: null,
      sensorVirtualId: null,
      max: null,
      min: null,
      graphicalViews: [],
      equipamentos: [],
    }
  },
  validations: {
    graphicalViewId: { required },
    max: { required },
    min: { required },
  },
  computed: {
    isEdit() {
      return this.componente !== null
    },
  },
  async beforeMount() {
    if (this.componente !== null) {
      this.graphicalViewId = this.componente.value.graphicalViewId
      this.sensorId = this.componente.value.sensorId
      this.max = this.componente.value.max
      this.min = this.componente.value.min
      this.sensorVirtualId = this.componente.value.sensorVirtualId
    }

    // http.get retorna null em erro (ja exibe o toast); sem o fallback o acesso
    // a .graphicalViews lanca e derruba o beforeMount.
    const promise1 = http.get(`graphical-view`).then((e) => {
      this.graphicalViews = e?.graphicalViews ?? []
    })

    const promise2 = http
      .get(`local/${this.localId}/equipamentos`)
      .then((e) => {
        this.equipamentos = e.equipamentos
      })

    await Promise.all([promise1, promise2])
  },
  methods: {
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (this.sensorId === null && this.sensorVirtualId === null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um sensor ou um sensor virtual',
        })
        return
      }

      if (this.max <= this.min) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'O valor máximo deve ser maior que o valor mínimo',
        })
        return
      }

      let response

      const value = {
        graphicalViewId: this.graphicalViewId,
        sensorId: this.sensorId,
        max: this.max,
        min: this.min,
        sensorVirtualId: this.sensorVirtualId,
      }

      if (this.isEdit) {
        response = await http.put(`/view/componente`, {
          id: this.componente.id,
          value: value,
          z: this.componente.z,
        })
      } else {
        response = await http.post(`/view/componente`, {
          tipo: ComponenteTipo.GraphicalView,
          viewId: this.viewId,
          value: value,
        })
      }

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped></style>
